// FileExplorer.js
// Simple file explorer sidebar for Zolaid IDE
import React, { useState, useEffect } from 'react';

const fetchFiles = async () => {
  // Placeholder: Replace with real API call to fetch file tree
  return [
    { name: 'App.js', path: 'src/App.js', type: 'file' },
    { name: 'AIAssistant.js', path: 'src/AIAssistant.js', type: 'file' },
    { name: 'AdvancedAIEngine.js', path: 'src/AdvancedAIEngine.js', type: 'file' },
    { name: 'SidebarSearch.js', path: 'src/SidebarSearch.js', type: 'file' },
    { name: 'components', path: 'src/components', type: 'folder', children: [] },
  ];
};

const FileExplorer = ({ onFileOpen }) => {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    fetchFiles().then(setFiles);
  }, []);

  const renderFile = (file) => {
    if (file.type === 'file') {
      return (
        <div key={file.path} className="file-item" onClick={() => onFileOpen(file.path)} style={{ cursor: 'pointer', paddingLeft: 16 }}>
          📄 {file.name}
        </div>
      );
    }
    if (file.type === 'folder') {
      return (
        <div key={file.path} className="folder-item" style={{ paddingLeft: 8 }}>
          📁 {file.name}
          {file.children && file.children.map(renderFile)}
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ width: 220, background: '#181818', color: '#fff', height: '100%', overflowY: 'auto', borderRight: '1px solid #222' }}>
      <div style={{ padding: 12, fontWeight: 'bold', borderBottom: '1px solid #222' }}>File Explorer</div>
      <div>{files.map(renderFile)}</div>
    </div>
  );
};

export default FileExplorer;
